export const cardStyle = {
    backgroundColor: 'white',
    // eslint-disable-next-line no-restricted-globals
    maxHeight: screen.height/2,
    width: '100%',
    // eslint-disable-next-line no-restricted-globals
    minHeight: screen.height/2,
    margin: '0 auto',
    marginTop: 75,
    borderRadius: 30,
    boxShadow: '0px 0px 5px #636f83ff',
}

export const promptStyle = {
    color: 'black',
    fontSize: '20px',
    fontFamily: 'Segoe UI',
    display: 'flex',
    justifyContent: 'center',

}

export const buttonStyle = {
    backgroundColor: '#70a6ffff',
    color: 'white',
    margin: '4px',
    borderRadius: '7px',
    border: 'none',
    fontSize: '16px',
};

export const textButton = {
    backgroundColor: '#70a6ffff',
    color: 'white',
    borderRadius: '7px',
    border: 'none',
    fontSize: '16px',
    alignItems: 'center',
    height: '42px'
}
export const iconButton = {
    backgroundColor: 'white',
    borderRadius: '7px',
    borderColor: 'gray',
    width: '40px'
}



export const dropdownToggleStyle = {
    backgroundColor: 'white',
    color: 'black',
    margin: '8px',
    width: '350px',
    borderRadius: '7px',
    borderColor: 'grey',
    fontSize: '16px'
};

export const dropdownMenuStyle = {
    backgroundColor: 'white',
    color: 'black',
    width: '350px',
    borderRadius: '7px',
    borderColor: 'grey',
    fontSize: '16px',
};




export const centeredDivStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
};